import { apiResourceUrl } from "@ploy-lib/core";
import { BaseResource } from "./BaseResource";
export class SectionTemplateResource extends BaseResource {
    pk() {
        return this.sectionTemplateId?.toString();
    }
}
SectionTemplateResource.urlRoot = apiResourceUrl("sectiontemplate");
//# sourceMappingURL=SectionTemplateResource.js.map